import type * as Types from 'app/types/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopifyAdminQueryQueryVariables = Types.Exact<{
  query: Types.Scalars['String']['input'];
  variables?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type ShopifyAdminQueryQueryResponse = Pick<Types.Query, 'shopifyAdminQuery'>;

export const ShopifyAdminQueryDocument = `
    query ShopifyAdminQuery($query: String!, $variables: Map) {
  shopifyAdminQuery(query: $query, variables: $variables)
}
    `;

export const useShopifyAdminQueryQuery = <TData = ShopifyAdminQueryQueryResponse, TError = unknown>(
  variables: ShopifyAdminQueryQueryVariables,
  options?: UseQueryOptions<ShopifyAdminQueryQueryResponse, TError, TData>,
) => {
  return useQuery<ShopifyAdminQueryQueryResponse, TError, TData>(
    ['ShopifyAdminQuery', variables],
    appFetcher<ShopifyAdminQueryQueryResponse, ShopifyAdminQueryQueryVariables>(
      ShopifyAdminQueryDocument,
      variables,
    ),
    options,
  );
};

useShopifyAdminQueryQuery.getKey = (variables: ShopifyAdminQueryQueryVariables) => [
  'ShopifyAdminQuery',
  variables,
];
